export const FETCH_COMPETITIONS = 'competitionActions/FETCH_COMPETITIONS';
export const FETCH_COMPETITIONS_SUCCESS =
  'competitionActions/FETCH_COMPETITIONS_SUCCESS';
export const FETCH_COMPETITIONS_FAILED =
  'competitionActions/FETCH_COMPETITIONS_FAILURE';

export const CREATE_COMPETITION = 'competitionActions/CREATE_COMPETITION';
export const CREATE_COMPETITION_SUCCESS =
  'competitionActions/CREATE_COMPETITION_SUCCESS';
export const CREATE_COMPETITION_FAILED =
  'competitionActions/CREATE_COMPETITION_FAILURE';

export const UPDATE_COMPETITION = 'competitionActions/UPDATE_COMPETITION';
export const UPDATE_COMPETITION_SUCCESS =
  'competitionActions/UPDATE_COMPETITION_SUCCESS';
export const UPDATE_COMPETITION_FAILED =
  'competitionActions/UPDATE_COMPETITION_FAILURE';

export const DELETE_COMPETITION = 'competitionActions/DELETE_COMPETITION';
export const DELETE_COMPETITION_SUCCESS =
  'competitionActions/DELETE_COMPETITION_SUCCESS';
export const DELETE_COMPETITION_FAILED =
  'competitionActions/DELETE_COMPETITION_FAILURE';

export const CONNECT_POST = 'competitionActions/CONNECT_POST';
export const CONNECT_POST_SUCCESS = 'competitionActions/CONNECT_POST_SUCCESS';
export const CONNECT_POST_FAILED = 'competitionActions/CONNECT_POST_FAILURE';

export const FETCH_COMPETITION_POSTS =
  'competitionActions/FETCH_COMPETITION_POSTS';
export const FETCH_COMPETITION_POSTS_SUCCESS =
  'competitionActions/FETCH_COMPETITION_POSTS_SUCCESS';
export const FETCH_COMPETITION_POSTS_FAILED =
  'competitionActions/FETCH_COMPETITION_POSTS_FAILURE';

export function fetchCompetitions() {
  return {
    type: FETCH_COMPETITIONS,
  };
}

export function fetchCompetitionsSuccess(competitions) {
  return {
    type: FETCH_COMPETITIONS_SUCCESS,
    competitions,
  };
}

export function fetchCompetitionsFailed(err) {
  return {
    type: FETCH_COMPETITIONS_FAILED,
    err,
  };
}

export function createCompetitions(details) {
  return {
    type: CREATE_COMPETITION,
    details,
  };
}

export function createCompetitionsSuccess(competition) {
  return {
    type: CREATE_COMPETITION_SUCCESS,
    competition,
  };
}

export function createCompetitionsFailed(err) {
  return {
    type: CREATE_COMPETITION_FAILED,
    err,
  };
}

export function updateCompetitions(id, details) {
  return {
    type: UPDATE_COMPETITION,
    details,
    id,
  };
}

export function updateCompetitionsSuccess(competition) {
  return {
    type: UPDATE_COMPETITION_SUCCESS,
    competition,
  };
}

export function updateCompetitionsFailed(err) {
  return {
    type: UPDATE_COMPETITION_FAILED,
    err,
  };
}

export function deleteCompetitions(id) {
  return {
    type: DELETE_COMPETITION,
    id,
  };
}

export function deleteCompetitionsSuccess(competition) {
  return {
    type: DELETE_COMPETITION_SUCCESS,
    competition,
  };
}

export function deleteCompetitionsFailed(err) {
  return {
    type: DELETE_COMPETITION_FAILED,
    err,
  };
}

export function connectPost(details, remove, winner) {
  return {
    type: CONNECT_POST,
    details,
    remove,
    winner,
  };
}

export function connectPostSuccess(competition, remove, postId) {
  return {
    type: CONNECT_POST_SUCCESS,
    competition,
    remove,
    postId,
  };
}

export function connectPostFailed(err) {
  return {
    type: CONNECT_POST_FAILED,
    err,
  };
}

export function fetchCompetitionPosts(filters) {
  return {
    type: FETCH_COMPETITION_POSTS,
    filters,
  };
}

export function fetchCompetitionPostsSuccess(posts, statuses) {
  return {
    type: FETCH_COMPETITION_POSTS_SUCCESS,
    posts,
    statuses,
  };
}

export function fetchCompetitionPostsFailed(err) {
  return {
    type: FETCH_COMPETITION_POSTS_FAILED,
    err,
  };
}
